import { JupiterTheme, MockHook } from '@jupiterone/jupiter-web-toolkit';
import { Button, MenuItem, TextField } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import useReportIssueFormLogic, {
  ReportIssueFormComponentProps,
  Severity,
} from './useReportIssueFormLogic';

const useStyles = makeStyles((theme: JupiterTheme) => {
  return createStyles({
    container: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      '& > *:last-child': {
        marginTop: theme.spacing(1),
      },
      '& > *': {
        marginBottom: theme.spacing(1),
      },
    },
  });
});

export const ReportIssueFormComponent = ({
  loading,
  errors,
  handleChange,
  handleSubmit,
}: ReportIssueFormComponentProps) => {
  const classes = useStyles();
  return (
    <form className={classes.container} onSubmit={handleSubmit}>
      <TextField
        label="Title"
        name="title"
        helperText={errors?.title}
        error={Boolean(errors?.title)}
        onChange={handleChange}
      />
      <TextField
        label="Steps to reproduce"
        name="stepsToReproduce"
        multiline
        rowsMax={8}
        helperText={errors?.stepsToReproduce}
        error={Boolean(errors?.stepsToReproduce)}
        onChange={handleChange}
      />
      <TextField
        label="Expected Behavior"
        name="expectedBehavior"
        multiline
        rowsMax={8}
        helperText={errors?.expectedBehavior}
        error={Boolean(errors?.expectedBehavior)}
        onChange={handleChange}
      />
      <TextField
        label="Severity"
        name="severity"
        helperText={errors?.severity}
        error={Boolean(errors?.severity)}
        onChange={handleChange}
        select
        defaultValue={Severity.MEDIUM}
      >
        {Object.values(Severity).map((severity) => {
          return (
            <MenuItem key={severity} value={severity}>
              {severity}
            </MenuItem>
          );
        })}
      </TextField>
      <Button
        disabled={loading}
        type="submit"
        variant="contained"
        color="primary"
      >
        Submit
      </Button>
    </form>
  );
};

export default MockHook.withHookHoc(
  ReportIssueFormComponent,
  useReportIssueFormLogic
);
